import { DateTime } from 'luxon'

import { UserLoginTokenResponseDTO } from '@/core/api/dtos/response/users/userLoginToken'
import { UserLoginToken } from '@/core/api/entities/user/userLoginToken'

export class UserLoginTokenMapper {
	static toEntity(dto: UserLoginTokenResponseDTO): UserLoginToken {
		return new UserLoginToken({
			userId: dto.user_id,
			token: dto.token,
			createdAt: DateTime.fromISO(dto.created_at),
			expiresAt: DateTime.fromISO(dto.expires_at),
			url: dto.url,
		})
	}
}
